import React from 'react';

import { FIELD_DETAILS_BY_FIELD_TYPE } from '../../views/constants/fieldConstants';
import { Field } from '../../types';
import MiniCard from '../MiniCard';


const FieldMiniCard = ({ field }: { field: Field }) => {
  const details = FIELD_DETAILS_BY_FIELD_TYPE[field.type];
  return (
    <MiniCard
      icon={details.icon}
      label={field.name}
      description={details.label}
    />
  );
};

export default FieldMiniCard;
